import { render, staticRenderFns } from "./AppointmentsView.vue?vue&type=template&id=962d8bd0&scoped=true&lang=pug"
import script from "./AppointmentsView.vue?vue&type=script&lang=js"
export * from "./AppointmentsView.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsView.vue?vue&type=style&index=0&id=962d8bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962d8bd0",
  null
  
)

export default component.exports